import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'; // Pop-up ke liye import kiya
import { API_BASE_URL } from "../config/api";

function ChangeSchool() {
  const navigate = useNavigate();
  const parentId = localStorage.getItem("parentId");
  const [currentSchool, setCurrentSchool] = useState({
    name: localStorage.getItem("schoolName") || "",
    code: localStorage.getItem("schoolCode") || "",
  });
  const [newSchool, setNewSchool] = useState({ name: "", code: "" });
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadSchoolData = async () => {
      try {
        const requests = [axios.get(`${API_BASE_URL}/schools`)];
        if (parentId) requests.push(axios.get(`${API_BASE_URL}/parent/parent/${parentId}`));

        const [schoolsRes, parentRes] = await Promise.all(requests);
        setSchools(Array.isArray(schoolsRes.data) ? schoolsRes.data : []);

        const parentSchool = parentRes?.data?.schoolId;
        if (parentSchool) {
          setCurrentSchool({
            name: parentSchool.name || localStorage.getItem("schoolName") || "",
            code: parentSchool.schoolCode || localStorage.getItem("schoolCode") || "",
          });
        }
      } catch (err) {
        console.error("School data fetch failed", err);
      }
    };

    loadSchoolData();
  }, [parentId]);

  const matchedNewSchool = useMemo(() => {
    const normalizedCode = newSchool.code.trim().toUpperCase();
    if (!normalizedCode) return null;

    return schools.find(
      (school) => String(school.schoolCode || "").toUpperCase() === normalizedCode
    );
  }, [newSchool.code, schools]);

  useEffect(() => {
    setNewSchool((prev) => ({
      ...prev,
      name: matchedNewSchool?.name || "",
    }));
  }, [matchedNewSchool]);

  const handleNewCodeChange = (e) => {
    setNewSchool((prev) => ({
      ...prev,
      code: e.target.value.trim().toUpperCase(),
    }));
  };

  const changeSchool = async (e) => {
    e.preventDefault();

    if (!parentId) {
      Swal.fire({
        icon: 'error',
        title: 'Login Required',
        text: 'Please login first to change school!',
        confirmButtonColor: '#3085d6',
      });
      return;
    }

    const nextSchoolCode = newSchool.code.trim().toUpperCase();

    if (!nextSchoolCode) {
      Swal.fire({
        icon: 'warning',
        title: 'School Code Required',
        text: 'Please enter the new school code.',
        confirmButtonColor: '#097969',
      });
      return;
    }

    setLoading(true);

    try {
      const res = await axios.put(
        `${API_BASE_URL}/parent/change-school/${parentId}`,
        { schoolCode: nextSchoolCode }
      );

      if (res.data.success) {
        // Success Pop-up
        await Swal.fire({
          icon: 'success',
          title: 'School Updated!',
          text: res.data.message || 'Your school has been changed successfully.',
          timer: 2000,
          showConfirmButton: false,
        });

        // LocalStorage update
        localStorage.setItem("schoolId", res.data.schoolId);
        localStorage.setItem("schoolName", res.data.schoolName || matchedNewSchool?.name || newSchool.name || "");
        localStorage.setItem("schoolCode", res.data.schoolCode || nextSchoolCode);

        // Cart clear
        localStorage.removeItem("cart");

        // Event dispatch
        window.dispatchEvent(new Event("schoolChange"));

        // Navigation aur Reload
        navigate("/parent/uniform", { replace: true });
        window.location.reload(); 
      }
    } catch (err) {
      // Error Pop-up
      Swal.fire({
        icon: 'error',
        title: 'Change Failed',
        text: err.response?.data?.message || "Something went wrong. Please try again.",
        confirmButtonColor: '#d33',
      });
    } finally {
      setLoading(false);
      setNewSchool({ name: "", code: "" });
    }
  };

  return (
    <div
      style={{
      textAlign: "center",
      padding: "60px",
      display: "flex",
      justifyContent: "center",
      backgroundImage:
        "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight:"700px"
    }}
    >
      <div className="container col-md-4" style={{display:"flex" , justifyContent:"center",alignItems:"center"}}>
        <form
          onSubmit={changeSchool}
         className="form-control p-4 shadow"
          style={{
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.3)",
            width: "min(100%, 520px)"
          }}
        >
          <h3 className="p-4 text-light">Change School Admission</h3>

          <div className="text-start w-75 mx-auto mb-3">
            <label className="form-label text-light fw-semibold mb-1">Old School Name</label>
            <input
              className="form-control text-center mb-3"
              value={currentSchool.name || "Current school not found"}
              readOnly
            />

            <label className="form-label text-light fw-semibold mb-1">Old School Code</label>
            <input
              className="form-control text-center"
              value={currentSchool.code || "N/A"}
              readOnly
            />
          </div>

          <hr className="border-light opacity-50 w-75 mx-auto" />

          <div className="text-start w-75 mx-auto mb-3">
            <label className="form-label text-light fw-semibold mb-1">New School Name</label>
            <input
              className="form-control text-center mb-3"
              placeholder="School name will appear here"
              value={newSchool.name}
              readOnly
            />

            <label className="form-label text-light fw-semibold mb-1">New School Code</label>
            <input
              className="form-control text-center"
              placeholder="Enter New School Code"
              value={newSchool.code}
              onChange={handleNewCodeChange}
              required
              disabled={loading}
            />
            {newSchool.code && !matchedNewSchool && (
              <small className="text-warning d-block mt-2 text-center">
                No school found with this code.
              </small>
            )}
          </div>

          <button 
            className="animated-btn btn border-1 w-75 border-light text-light"
            disabled={loading}
          >
            <span className=" me-2">Update School</span>
            
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangeSchool;
